






















































import {Component, Vue} from 'vue-property-decorator'
import {delMerchantsLevel, LevelListDto} from "@/api/customerManage";
import {Getter} from "vuex-class";

@Component({
    name: 'DelLevel'
})
export default class DelLevel extends Vue {
    showConfirm = false
    levelId = ''
    toLevelId = ''
    toLevelName = ''
    showOtherLevel = false
    toLevelList: LevelListDto[] = []

    show (data: { id: string, toLevelList: LevelListDto[] }) {
        this.showConfirm = true
        this.levelId = data.id
        this.toLevelList = data.toLevelList
        this.toLevelId = ''
        this.toLevelName = ''
    }

    changeLevel (data: LevelListDto) {
        this.toLevelId = data.levelId
        this.toLevelName = data.levelName
    }

    confirmFunc () {
      (this.$refs.handleForm as any).validate().then(() => {
        if (!this.toLevelId) {
          this.$emit('reloadList')
          return this.$toast.fail('请选择可定商品分类')
        }
        const params = {
          levelId: this.levelId,
          toLevelId: this.toLevelId
        }
        delMerchantsLevel(params).then(() => {
            this.$toast.success({
                message: '删除成功',
                duration: 1000,
                onClose: () => {
                  setTimeout(()=>{
                    this.$emit('reloadList')
                    this.cancel()
                  },200)
                }
            })

        }).catch(() => {})
      })

    }

    cancel () {
        this.showConfirm = false
        this.showOtherLevel = false;
         (this.$refs.handleForm as any).resetValidation()
    }
}
